import * as CryptJS from "crypto-js"
import * as base64 from "base-64"

import { config } from "config/config"
import * as API from "utils/api"
import { APIResponse } from "./types"
import dayjs from "dayjs"

const AESEncrypt = (msg: string) => {
  const key = CryptJS.enc.Base64.parse(config.api.auth.key)
  const iv = CryptJS.enc.Base64.parse(config.api.auth.iv)
  const options = {
    iv: iv,
    mode: CryptJS.mode.CBC,
    padding: CryptJS.pad.Pkcs7,
  }
  const encrypted = CryptJS.AES.encrypt(msg, key, options)
  return encrypted.ciphertext.toString()
}

const base64ToString = (str: string) => {
  return btoa(unescape(encodeURIComponent(str)))
}

const Login: API.RequestLogin<APIResponse.Res | {}> = async (
  user_branch: string,
  user_id: string,
  user_pw: string
) => {
  const dateformat = dayjs(new Date()).format("YYYYMMDDHHmmss")
  // auth_text："YYYYMMDDHHmmss" + ":" + "パスワード"
  const auth_text = base64ToString(dateformat + "_" + user_pw)
  const Authorization = `Basic ${base64.encode(
    config.api.auth.WebRichLogin + ":" + config.api.auth.WebRichLoginPw
  )}`

  const headers = {
    Authorization: Authorization,
    "X-API-Account": user_branch + user_id,
    "X-API-AuthText": auth_text,
    "X-APP-Version": "1.0",
    "X-API-Version": "1.0",
  }
  return await API.request("POST", "Login", undefined, headers)
}
const OpenLogin = async () => {
  const Authorization = `Basic ${base64.encode(
    config.api.auth.openLogin + ":" + config.api.auth.WebRichLoginPw
  )}`

  const headers = {
    Authorization: Authorization,
    "X-APP-Version": "1.0",
    "X-API-Version": "1.0",
  }
  return await API.request("POST", "Login", undefined, headers)
}

//todo削除確認
const ProfitSummary: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request("GET", "Message/ProfitSummary", params, headers)
}

export default {
  ProfitSummary,
  Login,
  OpenLogin,
}
